import DVRSection from "./section";

var LiveModel = DVRSection.extend({
    parse: function (response) {
        response = LiveModel.__super__.parse.apply(this, arguments);
        response.endTimestamp = Infinity;

        return response;
    },

    getEndTime: function () {
        return Infinity;
    }
});

export default LiveModel;
